import { req,reqFile ,importFile} from './axiosFun';
/** 系统设置 **/
/**
 * 图片上传
 **/
//图片上传
export const uploadFile = (params) => { return reqFile("post", "/yishantong-ui/fileUpload/ossBatch", params) };
/**
 * 账号管理
 **/
// 帐号列表
export const qrySysUserist = (params) => { return req("post", "/yishantong-ui/sys/qrySysUserist", params) };

// 添加帐号
export const addSysUser = (params) => { return req("post", "/yishantong-ui/sys/addSysUser", params) };

// 修改帐号
export const upSysUser = (params) => { return req("post", "/yishantong-ui/sys/upSysUser", params) };

// 修改帐号
export const delSysUser = (params) => { return req("post", "/yishantong-ui/sys/delSysUser", params) };

/**
 * 角色设置
 **/
// 角色列表
export const qrySysRoleList = (params) => { return req("post", "/yishantong-ui/sys/qrySysRoleList", params) };

// 添加角色
export const addSysRole = (params) => { return req("post", "/yishantong-ui/sys/addSysRole", params) };

// 修改角色
export const upSysRole = (params) => { return req("post", "/yishantong-ui/sys/upSysRole", params) };

//修改角色和权限
export const upSysRoleMenu = (params) => { return req("post", "/yishantong-ui/sys/upSysRoleMenu", params) };

// 删除角色
export const delSysRole = (params) => { return req("post", "/yishantong-ui/sys/delSysRole", params) };

/**
 * 菜单设置
 **/
// 菜单列表
export const qrySysMenuList = (params) => { return req("post", "/yishantong-ui/sys/qrySysMenuList", params) };

//新增菜单
export const addSysMenu = (params) => { return req("post", "/yishantong-ui/sys/addSysMenu", params) };

// 修改菜单
export const upSysMenu = (params) => { return req("post", "/yishantong-ui/sys/upSysMenu", params) };

// 删除菜单
export const delSysMenu = (params) => { return req("post", "/yishantong-ui/sys/delSysMenu", params) };

/**
 * 短信发送记录
 **/
// 查询短信发送记录列表(分页)
export const qrySmsLogList = (params) => { return req("post", "/yishantong-ui/smsLog/qrySmsLogList", params) };

//删除短信发送记录
export const delSmsLog = (params) => { return req("post", "/yishantong-ui/smsLog/delSmsLog", params) };

// 批量删除短信发送记录
export const delallSmsLog = (params) => { return req("post", "/yishantong-ui/smsLog/delallSmsLog", params) };

// 根据id导出短信发送记录列表
export const smsLogExcel = (params) => { return importFile("post", "/yishantong-ui/smsLog/smsLogExcel", params) };

// 导出短信发送记录列表
export const smsLogListExcel = (params) => { return importFile("post", "/yishantong-ui/smsLog/smsLogListExcel", params) };

/**
 * 操作日志
 **/
// 查询操作日志记录列表(分页)
export const qrySystemLogList = (params) => { return req("post", "/yishantong-ui/sys/qrySystemLogList", params) };

/**
 * 数据备份
 **/
// 查询数据备份列表(分页)
export const qrySqlBackupList = (params) => { return req("post", "/yishantong-ui/systemSqlBackup/qrySqlBackupList", params) };

// 数据库sql导出
export const importSql = (params) => { return importFile("post", "/yishantong-ui/systemSqlBackup/importSql", params) };

// 根据数据库备份数据库复原
export const sqlBackup = (params) => { return req("post", "/yishantong-ui/systemSqlBackup/sqlBackup", params) };



// WEBPACK FOOTER //
// ./src/api/sysApi.js